import { generateClient } from 'aws-amplify/api';
import { RESET_ENTITY, RESET_ALL } from '../lib/graphql/mutations';

const client = generateClient();

export function useReset() {
  async function reset(entityName?: string): Promise<void> {
    if (entityName) {
      await client.graphql({
        query: RESET_ENTITY,
        variables: { entityName },
      });
    } else {
      await client.graphql({ query: RESET_ALL });
    }
  }

  return { reset };
}
